module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av557-4a61f20b72aa4afecd6d488059efdb72.jpg";